import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import { deleteDesignation, getDesignation, insertDesignation, } from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function Designation() {
  const UID = getSecureItem("userId");
  const [addDesignationModal, setAddDesignationModal] = useState(false);
  const [editDesignationModal, setEditDesignationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [designations, setDesignations] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [DeleteDesignationId, setDeleteDesignationId] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
  const [isFilterVisible, setIsFilterVisible] = useState(false);


  const openEditDesignationModal = (data) => {
    setEditDesignationModal(!editDesignationModal);
    setDesignationData(data);
  };

  const [designationData, setDesignationData] = useState({
    Name: "",
    Narration: "",

  });
  const openAddDesignationModal = () => {
    setDesignationData({})

    setAddDesignationModal(!addDesignationModal);
  };



  const fetchDesignations = async () => {
    try {
      const data = await getDesignation(UID);
      console.log(data.data.data, "Fetched data");
      setDesignations(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching designations", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDesignationData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault(); // Prevent form submission
  //   setLoading(true);

  //   try {
  //     console.log(designationData, "Designation");
  //     const data = {
  //       ...designationData,
  //       UserId: UID,
  //     };
  //     const response = await insertDesignation(data);
     
      
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.error ||
  //       error.message ||
  //       "An unexpected error occurred.";

  //     if (errorMessage.includes("Duplicate Name")) {
  //       toast.error("The code or Name is already in use. Please use a unique code");
  //     } else {
  //       toast.error("Error occurred while adding Category.");
  //     }
  //     console.error("Error adding Category:", error);
  //   } finally{
  //     setLoading(false);
  //   }
 
   
  // };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission
    setLoading(true);
  
    try {
      console.log(designationData, "Designation");
      const data = {
        ...designationData,
        UserId: UID,
      };
      const response = await insertDesignation(data);
      // Check if the response is successful (e.g., response status or a success field)
      if (data) {
        toast.success("Designation added successfully!");
        fetchDesignations();
        openAddDesignationModal()
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";
  
      if (errorMessage.includes("Duplicate Name")) {
        toast.error(
          "The code or Name is already in use. Please use a unique code"
        );
      } else {
        toast.error("Error occurred while adding Category.");
      }
      console.error("Error adding Category:", error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true); // Set loading state to true

    try {
      const data = {
        ...designationData,
        UserId: UID,
      };
      const response = await insertDesignation(data);
      if (response.data.data.StatusCode === 200) {
        toast.success('Designation Updated Successfully'); // Show success toast
        fetchDesignations();
        openEditDesignationModal(); 
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code is already in use. Please use a unique code"); // Show specific error toast
      } else {
        toast.error("Error occurred while editing Group"); // General error toast
      }
      console.error("Error editing Group", error);
    } finally {
      setLoading(false); // Reset loading state
    }

  };


  // remove
  const handleDelete = async (designationId) => {
    const removeData = { Id: designationId, TableName: "Designation" };
    try {
      const res = await deleteDesignation(removeData, UID); // Ensure UID is defined in your scope
      if (res && res.data) {
        
        if (res.data.message === "Deleted Successfully") {
          toast.success("Designation deleted successfully");
          fetchDesignations(); 
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Failed to delete the Designation."); // Error toast
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Designation.";
        toast.error('Designation already using cannot delete');
      } else {
        console.error("Error removing Designation:", error);
        toast.error("Error deleting Designation. Please try again.");
      }
    }
  };


  const openModal = (designationId) => {
    setDeleteDesignationId(designationId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteDesignationId(null);
  };

  const confirmDelete = () => {
    if (DeleteDesignationId) {
      handleDelete(DeleteDesignationId);
    }
    closeModal();
  };

  const clearData = () => {
    setDesignationData({
      Id: "",
      Name: "",
      Narration: "",
      UserId: UID,
    });
  };

  const clearDataForEdit = () => {
    setDesignationData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      UserId: UID, // Assuming UID is a variable or state you have defined
    }));
  };


  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Designation",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.Narration?row.Narration:"N/A",
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.Code,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditDesignationModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];



  const filteredItems = dataFilter.filter(
    (item) =>
      (typeof item.Name === "string" && item.Name.toLowerCase().includes(filterText.toLowerCase())) ||
      (typeof item.Code === "number" && item.Code.toString().toLowerCase().includes(filterText.toLowerCase())) ||
      (typeof item.Narration === "string" && item.Narration.toLowerCase().includes(filterText.toLowerCase()))
  );
  
  

  const subHeaderComponentMemo = useMemo(() => {
  }, [filterText, resetPaginationToggle]);


  useEffect(() => {
    setLoading(true);
    fetchDesignations();
  }, []);

  useEffect(() => {
    if (designations && designations.length > 0) {
      const updatedData = designations.map((item, index) => ({
        Id: item.Id || "",
        Slno: index + 1,
        Name: item.Name || "",
        Narration: item.Narration || "",
        Code: item.Code || "",
        UserId: UID,
      }));
      setDataFilter(updatedData);
    }else{
      setDataFilter([])
    }
  }, [designations]);

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };


  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Designation?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete} // Confirm the deletion
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

<div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Designation" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Designation/code"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddDesignationModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={designations} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>

{/* ===============================================Add===================================================== */}

      {addDesignationModal && (
        <>

          <form onSubmit={handleSubmit}>

            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Designation
                  <span className="absolute top-0 right-0">
                    <button onClick={openAddDesignationModal} className="btn flex items-center justify-center">
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Designation <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={designationData?.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks </label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={designationData?.Narration}
                        onChange={handleChange}

                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Code <span style={{ color: 'red' }}>*</span>   </label>
                      <input
                        type="text"
                        id="Code"
                        name="Code"
                        placeholder="Code"
                        value={designationData?.Code}
                        onChange={handleChange}
                        required

                      />
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button className="btn btn-primary" disabled={loading}>
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div
            // onClick={openAddDesignationModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
      {editDesignationModal && (
        <>


        {/* ===============================================Add===================================================== */}


          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Designation
                  <span className="absolute top-0 right-0">
                    <button
                      type="button"
                      onClick={openEditDesignationModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                      Designation <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="Name"
                        placeholder="Name"
                        value={designationData?.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Remarks
                      </label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={designationData?.Narration}
                        onChange={handleChange}

                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        id="code"
                        name="Code"
                        placeholder="Code"
                        value={designationData?.Code}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openEditDesignationModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
